import { Observable, Subject, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { ResponsaveisData } from '../../interfaces/responsavel.interface';

@Injectable({
    providedIn: 'root',
})
export class ResponsavelService {
    /**
     * Cache para os responsáveis do aluno. Se já foram carregados, evita novas requisições à API.
     */
    public responsaveis: ResponsaveisData | null = null;

    /**
     * HttpService é injetado para realizar as requisições à API.
     */
    private httpService = inject(HttpService);

    /**
     * Busca os responsáveis de um aluno pelo seu RA (Registro Acadêmico).
     *
     * @param ra - O Registro Acadêmico do aluno.
     * @returns Um Observable contendo a resposta da API com os dados dos responsáveis.
     *
     * @remarks
     * Este método utiliza cache: se os responsáveis já foram carregados anteriormente,
     * retorna os dados em cache ao invés de fazer uma nova requisição à API.
     */
    index(ra: string): Observable<ResponsaveisData> {
        if (this.responsaveis) {
            return of(this.responsaveis);
        }
        return this.httpService
            .get<ResponsaveisData>(`v1/secretaria/aluno/${ra}/responsaveis`)
            .pipe(tap(res => (this.responsaveis = res)));
    }

    /**
     * Limpa o cache dos responsáveis. Deve ser chamado quando o aluno fizer logout ou quando for necessário atualizar os dados.
     */
    clearCache(): void {
        this.responsaveis = null;
    }
}
